import React from 'react'
import "./RecommendedVideos.css"
import VideoCard from './VideoCard.js';

function RecommendedVideos() {
    return (
        <div className="recommended">
            <h2>Recommended</h2>
            <div className="recommended__videos">
                <VideoCard
                    title="The Legendary Win with @Tanmay Bhat Ft. @Karan Singh Boomer"
                    views="293K views"
                    timestamp="1 month ago"
                    channel="GamerFleet"
                    channelImage="https://yt3.ggpht.com/a-/AOh14GhaZxV0Zww-h3yQ7l9LSN4dO2UVDv4qzMltpQ=s68-c-k-c0x00ffffff-no-rj-mo"
                    image="https://i.ytimg.com/vi/G0eGHKgBYbs/hq720.jpg?sqp=-oaymwEZCNAFEJQDSFXyq4qpAwsIARUAAIhCGAFwAQ==&rs=AOn4CLCH8TepXVn4msw9BS_pdEleVasd5A" />
                <VideoCard
                    title="How Domino's Makes its Pizza"
                    views="32M views"
                    timestamp="2 years ago"
                    channel="Food Insider"
                    channelImage="https://yt3.ggpht.com/a-/AOh14Gj5Gw-h9N9j6QkSkvykBwL12cuzYmZeQr4LoA=s68-c-k-c0x00ffffff-no-rj-mo"
                    image="https://i.ytimg.com/vi/jPQ87J_5qyw/hq720.jpg?sqp=-oaymwEZCNAFEJQDSFXyq4qpAwsIARUAAIhCGAFwAQ==&rs=AOn4CLBNBB96sX7iXg3myedE4bXSrMZqLQ" />
                <VideoCard
                    title="I Uber'd People And Let Them Keep The Car"
                    views="23M views"
                    timestamp="1 month ago"
                    channel="MrBeast"
                    channelImage="https://yt3.ggpht.com/a-/AOh14GivuiBq3tWPpHM0gKiN3RSpe6CgkcMGziRrRg=s68-c-k-c0x00ffffff-no-rj-mo"
                    image="https://i.ytimg.com/vi/IoZri9hq7z4/hq720.jpg?sqp=-oaymwEZCNAFEJQDSFXyq4qpAwsIARUAAIhCGAFwAQ==&rs=AOn4CLDe_IotHFSix9pk_GR_Kg1WX5NCIg" />
                <VideoCard
                    title="The Legendary Win with @Tanmay Bhat Ft. @Karan Singh Boomer"
                    views="293K views"
                    timestamp="1 month ago"
                    channel="GamerFleet"
                    channelImage="https://yt3.ggpht.com/a-/AOh14GhaZxV0Zww-h3yQ7l9LSN4dO2UVDv4qzMltpQ=s68-c-k-c0x00ffffff-no-rj-mo"
                    image="https://i.ytimg.com/vi/G0eGHKgBYbs/hq720.jpg?sqp=-oaymwEZCNAFEJQDSFXyq4qpAwsIARUAAIhCGAFwAQ==&rs=AOn4CLCH8TepXVn4msw9BS_pdEleVasd5A" />
                <VideoCard
                    title="How Domino's Makes its Pizza"
                    views="32M views"
                    timestamp="2 years ago"
                    channel="Food Insider"
                    channelImage="https://yt3.ggpht.com/a-/AOh14Gj5Gw-h9N9j6QkSkvykBwL12cuzYmZeQr4LoA=s68-c-k-c0x00ffffff-no-rj-mo"
                    image="https://i.ytimg.com/vi/jPQ87J_5qyw/hq720.jpg?sqp=-oaymwEZCNAFEJQDSFXyq4qpAwsIARUAAIhCGAFwAQ==&rs=AOn4CLBNBB96sX7iXg3myedE4bXSrMZqLQ" />
                <VideoCard
                    title="I Uber'd People And Let Them Keep The Car"
                    views="23M views"
                    timestamp="1 month ago"
                    channel="MrBeast"
                    channelImage="https://yt3.ggpht.com/a-/AOh14GivuiBq3tWPpHM0gKiN3RSpe6CgkcMGziRrRg=s68-c-k-c0x00ffffff-no-rj-mo"
                    image="https://i.ytimg.com/vi/IoZri9hq7z4/hq720.jpg?sqp=-oaymwEZCNAFEJQDSFXyq4qpAwsIARUAAIhCGAFwAQ==&rs=AOn4CLDe_IotHFSix9pk_GR_Kg1WX5NCIg" />
                <VideoCard
                    title="The Legendary Win with @Tanmay Bhat Ft. @Karan Singh Boomer"
                    views="293K views"
                    timestamp="1 month ago"
                    channel="GamerFleet"
                    channelImage="https://yt3.ggpht.com/a-/AOh14GhaZxV0Zww-h3yQ7l9LSN4dO2UVDv4qzMltpQ=s68-c-k-c0x00ffffff-no-rj-mo"
                    image="https://i.ytimg.com/vi/G0eGHKgBYbs/hq720.jpg?sqp=-oaymwEZCNAFEJQDSFXyq4qpAwsIARUAAIhCGAFwAQ==&rs=AOn4CLCH8TepXVn4msw9BS_pdEleVasd5A" />
                <VideoCard
                    title="How Domino's Makes its Pizza"
                    views="32M views"
                    timestamp="2 years ago"
                    channel="Food Insider"
                    channelImage="https://yt3.ggpht.com/a-/AOh14Gj5Gw-h9N9j6QkSkvykBwL12cuzYmZeQr4LoA=s68-c-k-c0x00ffffff-no-rj-mo"
                    image="https://i.ytimg.com/vi/jPQ87J_5qyw/hq720.jpg?sqp=-oaymwEZCNAFEJQDSFXyq4qpAwsIARUAAIhCGAFwAQ==&rs=AOn4CLBNBB96sX7iXg3myedE4bXSrMZqLQ" />
                <VideoCard
                    title="I Uber'd People And Let Them Keep The Car"
                    views="23M views"
                    timestamp="1 month ago"
                    channel="MrBeast"
                    channelImage="https://yt3.ggpht.com/a-/AOh14GivuiBq3tWPpHM0gKiN3RSpe6CgkcMGziRrRg=s68-c-k-c0x00ffffff-no-rj-mo"
                    image="https://i.ytimg.com/vi/IoZri9hq7z4/hq720.jpg?sqp=-oaymwEZCNAFEJQDSFXyq4qpAwsIARUAAIhCGAFwAQ==&rs=AOn4CLDe_IotHFSix9pk_GR_Kg1WX5NCIg" />
                <VideoCard
                    title="The Legendary Win with @Tanmay Bhat Ft. @Karan Singh Boomer"
                    views="293K views"
                    timestamp="1 month ago"
                    channel="GamerFleet"
                    channelImage="https://yt3.ggpht.com/a-/AOh14GhaZxV0Zww-h3yQ7l9LSN4dO2UVDv4qzMltpQ=s68-c-k-c0x00ffffff-no-rj-mo"
                    image="https://i.ytimg.com/vi/G0eGHKgBYbs/hq720.jpg?sqp=-oaymwEZCNAFEJQDSFXyq4qpAwsIARUAAIhCGAFwAQ==&rs=AOn4CLCH8TepXVn4msw9BS_pdEleVasd5A" />
                <VideoCard
                    title="How Domino's Makes its Pizza"
                    views="32M views"
                    timestamp="2 years ago"
                    channel="Food Insider"
                    channelImage="https://yt3.ggpht.com/a-/AOh14Gj5Gw-h9N9j6QkSkvykBwL12cuzYmZeQr4LoA=s68-c-k-c0x00ffffff-no-rj-mo"
                    image="https://i.ytimg.com/vi/jPQ87J_5qyw/hq720.jpg?sqp=-oaymwEZCNAFEJQDSFXyq4qpAwsIARUAAIhCGAFwAQ==&rs=AOn4CLBNBB96sX7iXg3myedE4bXSrMZqLQ" />
                <VideoCard
                    title="I Uber'd People And Let Them Keep The Car"
                    views="23M views"
                    timestamp="1 month ago"
                    channel="MrBeast"
                    channelImage="https://yt3.ggpht.com/a-/AOh14GivuiBq3tWPpHM0gKiN3RSpe6CgkcMGziRrRg=s68-c-k-c0x00ffffff-no-rj-mo"
                    image="https://i.ytimg.com/vi/IoZri9hq7z4/hq720.jpg?sqp=-oaymwEZCNAFEJQDSFXyq4qpAwsIARUAAIhCGAFwAQ==&rs=AOn4CLDe_IotHFSix9pk_GR_Kg1WX5NCIg" />
                <VideoCard
                    title="The Legendary Win with @Tanmay Bhat Ft. @Karan Singh Boomer"
                    views="293K views"
                    timestamp="1 month ago"
                    channel="GamerFleet"
                    channelImage="https://yt3.ggpht.com/a-/AOh14GhaZxV0Zww-h3yQ7l9LSN4dO2UVDv4qzMltpQ=s68-c-k-c0x00ffffff-no-rj-mo"
                    image="https://i.ytimg.com/vi/G0eGHKgBYbs/hq720.jpg?sqp=-oaymwEZCNAFEJQDSFXyq4qpAwsIARUAAIhCGAFwAQ==&rs=AOn4CLCH8TepXVn4msw9BS_pdEleVasd5A" />
                <VideoCard
                    title="How Domino's Makes its Pizza"
                    views="32M views"
                    timestamp="2 years ago"
                    channel="Food Insider"
                    channelImage="https://yt3.ggpht.com/a-/AOh14Gj5Gw-h9N9j6QkSkvykBwL12cuzYmZeQr4LoA=s68-c-k-c0x00ffffff-no-rj-mo"
                    image="https://i.ytimg.com/vi/jPQ87J_5qyw/hq720.jpg?sqp=-oaymwEZCNAFEJQDSFXyq4qpAwsIARUAAIhCGAFwAQ==&rs=AOn4CLBNBB96sX7iXg3myedE4bXSrMZqLQ" />
                <VideoCard
                    title="I Uber'd People And Let Them Keep The Car"
                    views="23M views"
                    timestamp="1 month ago"
                    channel="MrBeast"
                    channelImage="https://yt3.ggpht.com/a-/AOh14GivuiBq3tWPpHM0gKiN3RSpe6CgkcMGziRrRg=s68-c-k-c0x00ffffff-no-rj-mo"
                    image="https://i.ytimg.com/vi/IoZri9hq7z4/hq720.jpg?sqp=-oaymwEZCNAFEJQDSFXyq4qpAwsIARUAAIhCGAFwAQ==&rs=AOn4CLDe_IotHFSix9pk_GR_Kg1WX5NCIg" />

            </div>
        </div>
    )
}

export default RecommendedVideos
